import React, {PropTypes} from 'react';
import { Link, IndexLink } from 'react-router';
import LoadingDots from './LoadingDots';

const headerImgSource = require('./70-20-learn.png');

const Header = ({loading}) => {
  return (
    <div>
      <div className="header-img-container">
        <img src={headerImgSource} className="header-img"/>
      </div>
        {loading && <LoadingDots interval={100} dots={20}/>}
    </div>
  );
};

Header.propTypes = {
  loading: PropTypes.bool.isRequired
};

export default Header;



/** WEBPACK FOOTER **
 ** ./src/components/common/Header.js
 **/